const quantities = {};
const ACTIONS = {
  INCREASE: "increased",
  DECREASE: "decreased",
};
const SECTIONS = ["main-cart", "cart-drawer", "cart-bubble", "mini-cart"];

function deleteFromCart(line) {
  const currentQuantity = quantities[line];
  
  if (!currentQuantity) {
    console.error("Line item not found in quantities.");
    return;
  }

  const dataObj = {
    quantity: 0,  
    line: line,
    sections: [...SECTIONS, `${line}`],
    sections_url: window.location.pathname,
  };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataObj),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Product removed from cart.");
      delete quantities[line];
      removeExtraContainerDivs(data.sections);
      updateSections(data.sections);
      updateCartClass();
      fetchAndUpdate();
    })
    .catch((error) => {
      console.log("There was an error removing the item from the cart.", error);
    });
}

function updateCart(line, quantityChange, action) {
  let currentQuantity = quantities[line];
  if (!currentQuantity) {
    console.error("Line item not found in quantities.");
    return;
  }

  let newQuantity =
    action === ACTIONS.INCREASE
      ? currentQuantity + quantityChange
      : currentQuantity - quantityChange;

  quantities[line] = newQuantity;

  document
    .querySelectorAll(`.product-quantity[data-line="${line}"] input`)
    .forEach((inputEl) => {
      inputEl.value = newQuantity;
    });

  const dataObj = {
    quantity: action === ACTIONS.DECREASE && newQuantity < 1 ? 0 : newQuantity,
    line: line,
    sections: [...SECTIONS, `${line}`],
    sections_url: window.location.pathname,
  };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataObj),
  })
    .then((response) => response.json())
    .then((data) => {
      if (action === ACTIONS.DECREASE && newQuantity < 1) {
        console.log("Removing product from cart.");
        delete quantities[line];
        removeExtraContainerDivs(data.sections);
        updateSections(data.sections);
        fetchAndUpdate();
        updateCartClass();
      } else {
        console.log(`Product quantity ${action} successfully.`);
        removeExtraContainerDivs(data.sections);
        updateSections(data.sections);
        updateCartClass();
      }
    })
    .catch((error) => {
      console.log(
        `There was an error ${action} the quantity of the item in the cart.`,
        error
      );
    });
}

// function bindEventHandlers() {
//   const increaseButtons = document.querySelectorAll(".increase-quantity");
//   const decreaseButtons = document.querySelectorAll(".decrease-quantity");
//   const deleteItemButtons = document.querySelectorAll(".mini-cart__item__delete");
//   let button = document.querySelector(".mini-cart-button");
//   let cartDrawerContainer = document.getElementById("Cart-Drawer");

//   button.addEventListener("click", (e) => {
//     e.preventDefault();
//     document.body.classList.add("open-cc");
//     document.body.classList.add("open-cart");
//     cartDrawerContainer.classList.add("active");
//     cartDrawerContainer.focus();

//     setTimeout(() => {
//       let productRecommendations = cartDrawerContainer.querySelector(
//         ".product-recommendations--full"
//       );
//       if (productRecommendations) {
//         productRecommendations.classList.add("active");
//       }
//     });
//   });

//   const badges = document.querySelectorAll(".best-seller__latest p");

//   if (badges.length === 0) return;

//   const speed = 20;

//   badges.forEach((badge) => {
//     const totalDistance = badge.offsetWidth;
//     const duration = totalDistance / speed;
//     badge.style.animationDuration = `${duration}s`;
//   });

//   let sellingPlanSelectors = document.querySelectorAll(
//     '[name="selling-plan-build"]'
//   );
//   let loader = document.querySelector(".loader-cart");

//   sellingPlanSelectors.forEach(function (element, index) {
//     element.addEventListener("change", async function (e) {
//       let selectedIndex = e.target.selectedIndex;
//       sellingPlanSelectors.forEach(function (innerElement) {
//         innerElement.selectedIndex = selectedIndex;
//       });
//       loader.classList.add("active");

//       await updateProductsWithDelay(Array.from(sellingPlanSelectors), 100);

//       loader.classList.remove("active");
//     });
//   });

//   increaseButtons.forEach((button) => {
//     button.removeEventListener("click", handleIncrease);
//     button.addEventListener("click", handleIncrease);
//   });

//   decreaseButtons.forEach((button) => {
//     button.removeEventListener("click", handleDecrease);
//     button.addEventListener("click", handleDecrease);
//   });

//   deleteItemButtons.forEach((button) => {
//     button.removeEventListener("click", deleteItem);
//     button.addEventListener("click", deleteItem);
//   });
// }

function handleIncrease(event) {
  const line = event.currentTarget.getAttribute("data-line");
  updateCart(line, 1, "increased");
}

function handleDecrease(event) {
  const line = event.currentTarget.getAttribute("data-line");
  updateCart(line, 1, "decreased");
}

function deleteItem(event) {
  const line = event.currentTarget.getAttribute("data-index");
  deleteFromCart(line);
}

function removeExtraContainerDivs(sections) {
  for (const section in sections) {
    if (sections.hasOwnProperty(section)) {
      let sectionEl = document.createElement("div");
      sectionEl.innerHTML = sections[section];
      if (sectionEl.querySelector("#Cart-Drawer")) {
        sections[section] = sectionEl.querySelector("#Cart-Drawer").innerHTML;
      }
      if (sectionEl.querySelector(".product-quantity")) {
        sections[section] =
          sectionEl.querySelector(".product-quantity").innerHTML;
      }
      if (sectionEl.querySelector(".mini-cart")) {
        sections[section] = sectionEl.querySelector(".mini-cart").innerHTML;
      }
    }
  }
}

function updateSections(sections) {
  const cartElement = document.getElementById("Cart");
  const cartDrawerElement = document.getElementById("Cart-Drawer");
  const cartDrawerToggleElement = document.getElementById("cart-drawer-toggle");
  const miniCartElement = document.getElementById("mini-cart");

  if (sections["main-cart"] && cartElement) {
    cartElement.innerHTML = sections["main-cart"];
  }
  if (sections["cart-drawer"] && cartDrawerElement) {
    cartDrawerElement.innerHTML = sections["cart-drawer"];
  }
  if (sections["cart-bubble"] && cartDrawerToggleElement) {
    cartDrawerToggleElement.innerHTML = sections["cart-bubble"];
  }
  if (sections["mini-cart"] && miniCartElement) {
    miniCartElement.innerHTML = sections["mini-cart"];
    // bindEventHandlers();
    updateCartClass();
  }
}

function updateElementAttributes(newElem, targetElem) {
  Array.from(targetElem.attributes).forEach((attr) => {
    if (!newElem.hasAttribute(attr.name)) {
      targetElem.removeAttribute(attr.name);
    }
  });

  Array.from(newElem.attributes).forEach((attr) => {
    targetElem.setAttribute(attr.name, attr.value);
  });
}

function updateElementContent(newElem, targetElem) {
  updateElementAttributes(newElem, targetElem);

  const newNodes = Array.from(newElem.childNodes);
  const targetNodes = Array.from(targetElem.childNodes);

  for (let i = 0; i < newNodes.length || i < targetNodes.length; i++) {
    const newNode = newNodes[i];
    const targetNode = targetNodes[i];

    if (!targetNode) {
      targetElem.appendChild(newNode.cloneNode(true));
      continue;
    }

    if (!newNode) {
      targetElem.removeChild(targetNode);
      continue;
    }

    if (newNode.tagName === "IMG" && targetNode.tagName === "IMG") {
      continue;
    }

    if (
      newNode.nodeType !== targetNode.nodeType ||
      newNode.tagName !== targetNode.tagName
    ) {
      targetElem.replaceChild(newNode.cloneNode(true), targetNode);
      continue;
    }

    if (newNode.nodeType === Node.ELEMENT_NODE) {
      updateElementContent(newNode, targetNode);
    }
  }
}

function fetchAndUpdate() {
  const collectionHandle = document
    .querySelector("[data-collection-handle]")
    .getAttribute("data-collection-handle");
  fetch(`/collections/${collectionHandle}`)
    .then((response) => response.text())
    .then((data) => {
      let html_div = document.createElement("div");
      html_div.innerHTML = data;
      let miniCartResponse = html_div.querySelector(".mini-cart");
      let sectionsResponse = html_div.querySelectorAll(
        ".collection-products__right"
      );
      let targetElements = document.querySelectorAll(
        ".collection-products__right"
      );
      let miniCartTarget = document.querySelector(".mini-cart");

      if (sectionsResponse.length !== targetElements.length) {
        console.warn(
          "The number of sections on the page and in the response do not match"
        );
        return;
      }

      miniCartTarget.innerHTML = miniCartResponse.innerHTML;
      updateCartClass();
      targetElements.forEach((targetElement, index) => {
        updateElementContent(sectionsResponse[index], targetElement);
        updateQuantities(targetElement, index);
        // bindEventHandlers();
        AOS.refreshHard();
      });
    })
    .catch((error) => console.error("Error:", error));
}

function updateQuantities(targetElement) {
  let productQuantities = targetElement.querySelectorAll(
    ".product-quantity-input"
  );
  productQuantities.forEach((element) => {
    let line = element.getAttribute("data-line");
    quantities[line] = Number(element.value);
  });
}

document.addEventListener("line-item:change:end", function (evt) {
  fetchAndUpdate();
});

document.addEventListener("cart:item-added", function (evt) {
  fetchAndUpdate();
});

function updateCartClass() {
  let itemsWithConditionCount = 0;
  const cartItems = document.querySelectorAll(".mini-cart__item");

  cartItems.forEach((item) => {
    if (item.getAttribute("data-product-type") === "Build") {
      itemsWithConditionCount++;
    }
  });

  const miniCart = document.getElementById("shopify-section-mini-cart");
  if (itemsWithConditionCount > 0) {
    miniCart.classList.add("active");
    miniCart.classList.remove("not-active");
    document.body.classList.add("mini-cart-open");
  } else {
    miniCart.classList.remove("active");
    miniCart.classList.add("not-active");
    document.body.classList.remove("mini-cart-open");
  }
}

fetchAndUpdate();

document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-section-item");
  const filteringSections = document.querySelectorAll(".filtering-section");
  const tagFilters = document.querySelectorAll(".tag-filter");
  const collectionProducts = document.querySelectorAll(
    ".not-filtering-section"
  );
  const resetBtn = document.querySelector(".clear-filter");

  filteringSections.forEach((section) => {
    section.style.display = "none";
  });


  filterButtons.forEach((button) => {
    button.addEventListener("click", function () {
      let targetId = this.getAttribute("data-target");
      
      tagFilters.forEach((filter) => {
        filter.classList.remove('active');
      });

      filteringSections.forEach((section) => {
        section.style.display = "none";
      });
      collectionProducts.forEach((product) => {
        product.style.display = "none";
      });

      const activeSection = document.getElementById(targetId);
      activeSection.style.display = "block";
      activeSection.scrollIntoView({ behavior: "smooth", block: "start" });

      resetBtn.classList.remove("inactive");
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      if (!resetBtn.classList.contains("inactive")) {
        filteringSections.forEach((section) => {
          section.style.display = "none";
        });
        collectionProducts.forEach((product) => {
          product.style.display = "block";
        });

        resetBtn.classList.add("inactive");
      }
    });
  }
});

document.addEventListener("buildCartRemove", function (e) {
  fetchAndUpdate();
});

let button = document.querySelector(".mini-cart-button");
let cartDrawerContainer = document.getElementById("Cart-Drawer");

document.addEventListener("click", function(event) {
  let targetButton = event.target.closest(".mini-cart-button");
  if (targetButton && targetButton.classList.contains("mini-cart-button")) {
    event.preventDefault();
    let cartDrawerContainer = document.getElementById("Cart-Drawer");

    document.body.classList.add("open-cc");
    document.body.classList.add("open-cart");
    cartDrawerContainer.classList.add("active");
    cartDrawerContainer.focus();

    setTimeout(() => {
      let productRecommendations = cartDrawerContainer.querySelector(
        ".product-recommendations--full"
      );
      if (productRecommendations) {
        productRecommendations.classList.add("active");
      }
    });
  }
});